import { render, staticRenderFns } from "./SectionAsapLoan.vue?vue&type=template&id=46e9bee3&scoped=true&"
var script = {}
import style0 from "./SectionAsapLoan.vue?vue&type=style&index=0&id=46e9bee3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e9bee3",
  null
  
)

export default component.exports